import Vue from "vue"
import router from "./router"
import VueMeta from "vue-meta"
import Element from "element-ui"
import * as echarts from 'echarts';
import store from "./store"
import VueClipBoard from 'vue-clipboard2'
import VueCanvasPoster from 'vue-canvas-poster'
import Toasted from 'vue-toasted';
import BaiduMap from 'vue-baidu-map'
import * as socketApi from '@/utils/socket'
Vue.use(BaiduMap, {
  ak: 'Tt6XNYvuaTBKCqZQsoqS7TOPjR8uck8k'
});
Vue.use(Element)
Vue.use(VueClipBoard)
Vue.use(VueCanvasPoster)
Vue.use(Toasted)
import "element-ui/lib/theme-chalk/index.css"
import "./assets/styles/main.scss"
import "./assets/styles/element-variables.scss"
import './utils/directives.js' //弹框拖拽
import './assets/styles/iconfont1.css' //阿里云图标
import './assets/styles/font.css' //富文本样式
import 'font-awesome/css/font-awesome.min.css';
import App from "./App.vue"
import {Base64} from 'js-base64' //参数base64加密
import Util from "./utils/util"
import Config from "./utils/config.js"
import LocaStorage from "./utils/localstorage.js"

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$socketApi = socketApi
// 常用工具函数
Vue.prototype.$util = Util

Vue.prototype.$config = Config

Vue.prototype.$locaStorage = LocaStorage

Vue.prototype.$base64 = Base64
Vue.use(VueMeta)
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})
var EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})
window.vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app")
